import { render, staticRenderFns } from "./CaseLoss.vue?vue&type=template&id=5a5839e2&scoped=true"
import script from "./CaseLoss.vue?vue&type=script&lang=js"
export * from "./CaseLoss.vue?vue&type=script&lang=js"
import style0 from "./CaseLoss.vue?vue&type=style&index=0&id=5a5839e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5839e2",
  null
  
)

export default component.exports